import { render, staticRenderFns } from "./indexEn.vue?vue&type=template&id=4324d9e4&scoped=true&"
import script from "./indexEn.vue?vue&type=script&lang=js&"
export * from "./indexEn.vue?vue&type=script&lang=js&"
import style0 from "./indexEn.vue?vue&type=style&index=0&id=4324d9e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4324d9e4",
  null
  
)

export default component.exports